import { render, staticRenderFns } from "./OrgFilterForm.vue?vue&type=template&id=3edf11d8"
import script from "./OrgFilterForm.vue?vue&type=script&lang=js"
export * from "./OrgFilterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports